/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DashboardAlertsDto } from '../models/DashboardAlertsDto';
import type { DashboardStatsDto } from '../models/DashboardStatsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DashboardService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get dashboard statistics
   * @returns DashboardStatsDto Dashboard statistics retrieved successfully
   * @throws ApiError
   */
  public dashboardControllerGetStats(): CancelablePromise<DashboardStatsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/dashboard/stats',
    });
  }
  /**
   * Get dashboard alerts
   * @returns DashboardAlertsDto Dashboard alerts retrieved successfully
   * @throws ApiError
   */
  public dashboardControllerGetAlerts(): CancelablePromise<DashboardAlertsDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/dashboard/alerts',
    });
  }
  /**
   * Get recent activity
   * @returns any Recent activity retrieved successfully
   * @throws ApiError
   */
  public dashboardControllerGetRecentActivity(): CancelablePromise<Array<Record<string, any>>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/dashboard/recent-activity',
    });
  }
}
